// Inlined SVG mirrors assets/brand/lockup.svg but uses `currentColor` so it
// inherits the surrounding text color (making dark-mode trivial via Tailwind).

interface LockupProps {
  className?: string;
  "aria-label"?: string;
}

export function Lockup({ className, "aria-label": label = "Minuta" }: LockupProps) {
  return (
    <svg
      viewBox="0 0 640 140"
      role="img"
      aria-label={label}
      className={className}
      fill="currentColor"
    >
      <title>{label}</title>
      {/* Glyph: three pill bars (waveform "m") sharing baseline y=100 with the wordmark */}
      <g>
        <rect x="20" y="25" width="25" height="75" rx="12.5" />
        <rect x="57.5" y="0" width="25" height="100" rx="12.5" />
        <rect x="95" y="39.3" width="25" height="60.7" rx="12.5" />
      </g>
      {/* Wordmark */}
      <text
        x="160"
        y="100"
        fontFamily='"Inter Display", Inter, "SF Pro Display", system-ui, sans-serif'
        fontWeight={600}
        fontSize={96}
        letterSpacing="-3"
      >
        m
      </text>
      <text
        x="252"
        y="100"
        fontFamily='"Inter Display", Inter, "SF Pro Display", system-ui, sans-serif'
        fontWeight={600}
        fontSize={96}
        letterSpacing="-3"
      >
        inuta
      </text>
      {/* Micro-waveform on the "i" */}
      <g transform="translate(258, 28)" stroke="currentColor" strokeWidth={6} strokeLinecap="round" fill="none">
        <line x1="0" y1="8" x2="0" y2="16" />
        <line x1="10" y1="0" x2="10" y2="24" />
        <line x1="20" y1="6" x2="20" y2="18" />
      </g>
    </svg>
  );
}
